export const VERIFICATION_CODE_RESEND_TIMEOUT = 30;
export const EMAIL_VERIFICATION_CODE_LENGTH = 6;
